// Response for /api/frontend/v2/get-search-results
// Captured from dev CMS, LegId=b2e784ce-8f67-4575-8056-43fe76add14c
const searchResults = [
    {
        id: "arfq-128210459",
        recommended: false,
        category: "Super Light Jet",
        aircraftName: "Citation XLS+",
        photoData: [
            {
                id: "1668",
                url: "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/gneior1t/dcdcm-int.webp",
                alt: "Aircraft Image",
            },
            {
                id: "1667",
                url: "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/hcbdmagg/dcdcm.webp",
                alt: "Aircraft Image",
            },
        ],
        floorPlan: [
            {
                id: "1194",
                url: "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/tmgp3vb0/citation-xls-floor-plan.webp",
                alt: "Aircraft Floorplan",
            },
            {
                id: "1224",
                url: "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/yllhlagq/cj2-floor-plan.webp",
                alt: "Aircraft Floorplan",
            },
            {
                id: "1218",
                url: "https://shy-wa-dev-cms-e6c5bxhgbgfnecam.uksouth-01.azurewebsites.net/media/pkpdhjqt/g650-floorplan.png",
                alt: "Aircraft Floorplan",
            },
        ],
        seats: 8,
        departureTime: "23/12/2026 13:00",
        arrivalTime: "23/12/2026 15:27",
        headRoom: "1.73",
        cabinCrew: false,
        wifi: false,
        toilet: "No",
        hotGalley: true,
        bed: false,
        luggage: 7,
        co2: "2.5955",
        cruiseSpeed: "507",
        operatorCurrency: "USD",
        preferredCurrency: "EUR",
        email: "m@s.test.com",
        tailNumber: "D-CDCM",
        yom: "2012",
        uplift: 10.0,
        price: {
            gbp: 8851.0,
            eur: 10334.0,
            usd: 11935.0,
        },
        show: false,
        cateringOption: "No Catering Included",
        wifiOption: "No WIFI Available",
        flightAttendants: "N",
        smokingOption: "N",
        subjectToConditions: "None",
        ownerApproval: "N",
        subjectToWeight: "N",
        pilotsCount: null,
        fuelStop: 0,
        fuelStops: [0],
        notes: "",
        quoteExpiryDate: null,
        refurbishedYear: "2007",
        numberOfPilots: 2,
        cabinWidth: "12",
        cabinLength: "10",
        aircraftHeight: "1.73",
        pets: 0,
        petCounts: [0],
        departureDateTime: ["23/12/2026 13:00"],
        arrivalDateTime: ["23/12/2026 15:27"],
        duration: ["0:01:27:00"],
        isManualQuote: false,
        catering: {
            provided: true,
            notes: "Full bar and light snacks. Hot food available on request.",
        },
        isFleet: true,
        rawPrice: null,
    },
];

export default searchResults;
